import React, { useEffect, useRef} from "react";
import { useNavigate } from "react-router-dom";
import icons from "../../icons";
import { Link } from 'react-router-dom';
import  {charactersOnly, isValidWeakPassword, numberOnly, passwordLength,isValidStrongPassword, checkPassword, encodePassword} from "../../services/Util.js";
import { postAxiosResponse } from "../../services/authApiRoutes/APImethods";
import  { useState } from "react";
import { useSelector } from "react-redux";
import APIUrls from "../../services/APIUrls";
import $, { event } from "jquery";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [strongPassword,setStrongPassword]=useState(false)
  const [length,setLength]=useState(false)
  const [oneCharacterStatus,setOneCharacterStatus]=useState(false)
  const [oneNumberStatus,setOneNumberStatus]=useState(false)
  const [verifyPassword,setVerifyPassword]=useState({});
  const [weakPasswordStatus,setWeakPasswordStatus]=useState(false)
  const [passwordMatch,setPasswordMatch]=useState(true);
  const [status,setStatus]=useState(false);
  const [passwordStatus,setPasswordStatus]=useState(false)
  const [oldPassword, setOldPassword] = useState("");
  const [disableSavebutton, setDisableSaveButton] = useState(true);
  const [incorrectOldPassword, setIncorrectOldPassword] = useState("");
  const [incorrectNewPassword, setIncorrectNewPassword] = useState("")
  const focusRef = useRef();
  const owner = useSelector(
    (reduxStore) => reduxStore.loginSession
  ).value;

  const navigateToLogin = () => {
    setStatus(false)
    setPasswordStatus(false)
    navigate("/settings/my-account-profile");
  };
  useEffect(() => {
    document.body.classList.remove("color-contrast");
    focusRef.current.focus();
     $(document).on("click","#change-pass",function() {
      setTimeout(function() { 
        if($("#currentPassword").hasClass('error-alert')){
          $('#currPass').trigger('focus')
        }
        else{
          $('#newPass').trigger('focus')
        }
      },2500);
    });
  }, []);
  
  const passwordCheck=(event)=>{
    let password=event?.target?.value
    setDisableSaveButton(true);
    if(password.length > 0) {
        setIncorrectNewPassword("")
        setLength(passwordLength(password))
        setOneNumberStatus(charactersOnly(password))
        setOneCharacterStatus(numberOnly(password))
        setWeakPasswordStatus(isValidWeakPassword(password))
        setStrongPassword(isValidStrongPassword(password))
        if(isValidStrongPassword(password)){
            setWeakPasswordStatus(false)
        }if(passwordStatus){
            let match=checkPassword(password,verifyPassword.confirmPassword)
            setPasswordMatch(match);
            setDisableSaveButton(!match);
        }
        if(isValidWeakPassword(password) || isValidStrongPassword(password) ){
            setVerifyPassword({...verifyPassword,'password':password})
        }
    } else {
        setLength(0)
        setOneNumberStatus(false)
        setOneCharacterStatus(false)
        setWeakPasswordStatus(false)
        setStrongPassword(false)
    }
      
  }

  const currentPassword = (event) => {
    setIncorrectOldPassword("")
    setOldPassword(event.target.value);
  }

  const isVerifyPassword=(event)=>{
    let confirmPassword=event?.target?.value
    let match=checkPassword(verifyPassword?.password,confirmPassword)
    setPasswordMatch(match);
    setDisableSaveButton(!match);
    setPasswordStatus(true)
    if(match){
      setVerifyPassword({...verifyPassword,'confirmPassword':confirmPassword})
    }

  }

  const onFormSubmit = (event) =>{
    event.preventDefault()
    let data=verifyPassword;
    const params = new URLSearchParams();
    params.set("userId", owner.id);
    params.set("password", encodePassword(data.password));
    params.set("confirmPassword", encodePassword(data.confirmPassword));
    params.set("oldPassword", oldPassword);
    params.set("random", 0);
    params.set("encrypted", true);
    if(weakPasswordStatus || strongPassword){
        postAxiosResponse(APIUrls.CHANGE_PASSWORD+"?"+params.toString()).then((res) => {
            if(res.data.data.view !== "") {
                setPasswordStatus(false);
                navigateToLogin();
            } else {
                if(res.data.data.model.errors.length > 0) {
                    res?.data?.data?.model?.errors?.map((error) => {
                        if(error.field === "password") {
                            setIncorrectNewPassword("You can not use old password as new password.")
                        } else if(error.field === "oldPassword") {
                            setIncorrectOldPassword(error.defaultMessage);
                        }
                    })
                }
            }
        })
    }
  } 

  return (
    <div className="wrapper">
      <div className="sign-page">
        <div className="content">
          <div className="back" >
            <button type="button" onClick={navigateToLogin}>
              <i aria-hidden="true"></i>Back
            </button>
          </div>
          <div className="small-container">
            <div className="logo-block">
              <Link to="/">
                <img src={icons.OPAL_LOGO} alt="Logo" />
              </Link>
            </div>
            <div className={!status?"inner-content-wrap update-password ":"hide"}>
              <h1> Change Password</h1>
              <form onSubmit={onFormSubmit} name="passwordManagementForm" commandName="passwordManagement">
                <div className="wrap-form">
                    <div className="input-group">
                        <input
                        type="Password"
                        id="currPass"
                        className="form-control"
                        placeholder="Current Password"
                        aria-required="true"
                        name="curr-password"
                        autoComplete="off"
                        maxLength="64"
                        onChange={currentPassword}
                        ref={focusRef}
                        aria-describedby="currentPassword"
                        
                        />
                        {incorrectOldPassword && <p id="currentPassword" className="error-alert m-0 align-left" aria-label={incorrectOldPassword}>
                            {incorrectOldPassword}
                        </p>}
                    </div>
                  <div className="input-group">
                    <input
                      type="Password"
                      id="newPass"
                      className="form-control"
                      placeholder="New password"
                      aria-required="true"
                      aria-describedby="strenghtMsg"
                      name="password"
                      autoComplete="off"
                      maxLength="64"
                      onChange={passwordCheck}
                     
                    />
                    {length && <p id="strenghtMsg" className="error-alert m-0 align-left">
                        You need at least 8 characters.
                    </p>}
                    {incorrectNewPassword && <p id="strenghtMsg" className="error-alert m-0 align-left">
                        {incorrectNewPassword}
                    </p>}

                    {oneNumberStatus ?<p id="strenghtMsg" className="error-alert m-0 align-left">
                        You need at least 1 number.
                    </p>:""}
                    {oneCharacterStatus ?<p id="strenghtMsg" className="error-alert m-0 align-left">
                        You need at least 1 letter.
				    </p>:""}
                    <div className={strongPassword?"pass-strength-success":"hide"}>
                      Strong
                    </div>
                    <div className={weakPasswordStatus?"pass-strength-success":"hide"}>
                      Weak
                    </div>
                    <div aria-label="Password instructions" className="instruction">
                        Must have at least 8 characters, 1 number, and 1 letter.
                    </div>
                  </div>
                  <div className="input-group">
                    <input
                      type="Password"
                      className="form-control"
                      placeholder="Confirm new password"
                      aria-required="true"
                      name="confirmPassword"
                      maxLength="64"
                      autoComplete="off"
                      onChange={isVerifyPassword}
                      aria-describedby="confirmPass"
                      
                    />
                    {!passwordMatch ? 
                        <p id="confirmPass" className="error-alert align-left">The passwords do not match.</p> : <></>}
                    </div>
                    <div className="stricy-btn flex flex-center no-rightlist justify-end">
                        <div className="left flex">
                            <button id="change-pass" className="blue-btn" type="submit" disabled={disableSavebutton}>
                                Save
                            </button>
                            <button className="blue-btn" onClick={navigateToLogin}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}